import * as React from 'react'

import { PhoneNumberInput } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

export const PhoneNumber = ({ required = false }) => {
  const { getLabel, country, locale } = useIntl()

  return (
    <PhoneNumberInput
      id="phone"
      required={required}
      data-t="phone-number"
      label={getLabel('checkout.contact.phoneNumber')}
      defaultCountry={country}
      localeForTranslations={locale}
      countriesOrder={['GB', 'IE']}
      initialState={{
        value: '',
        isValid: undefined,
        isTouched: undefined,
      }}
      errorMessage={getLabel('checkout.contact.phoneNumber.errorMessage')}
      optionalText={getLabel('checkout.form.field.optional')}
      hideAsteriskSign={false}
    />
  )
}
